export enum Priority {
  Low = 0,
  Medium = 1,
  High = 2,
  Blocking = 3
}

export interface IPriority{
  name:string,
  value:number
}
